import { defineMessages } from 'react-intl';

export const messages: {
	workItemLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	workItemLabel: {
		id: 'relay.jira-dc-work-item.work-item.work-item-label',
		defaultMessage: 'Work item',
		description: 'Work item label',
	},
	issueLabel: {
		id: 'relay.jira-dc-work-item.issue-label',
		defaultMessage: 'Issue',
		description: 'Issue label',
	},
});
